import axios from 'axios'

// initial state
const state = {
  items: [],
  ready: false
}

// getters
const getters = {
  sites: (state) => state.items,
  current: (state) => {
    return state.items.find(item => (item.sitekey === window['vm'].$route.params.site))
  }
}

// actions
const actions = {
  LOAD_SITES_LIST: ({ commit, dispatch }) => {
    axios.get(process.env.API + '/account/')
      .then((response) => {
        commit('SET_SITES_LIST', { items: response.data.sites })
      }, (e) => {
        console.log(e)
      })
  },

  update: ({ commit, dispatch }, site) => {
    commit('UPDATE_SITE', { site: site })
  }
}

// mutations
const mutations = {

  SET_SITES_LIST: (state, { items }) => {
    state.items = items
    state.ready = true
  },

  UPDATE_SITE: (state, { site }) => {
    for (var i = 0; i < state.items.length; i++) {
      if (site.id === state.items[i].id) {
        Object.assign(state.items[i], site)
        return true
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sites.js